module.exports = __webpack_public_path__ + "img/jubilaciones.ec6cb43e.png";